import axios from 'axios';

export const getTables = () => {
  return axios.get(`/tables`);
};
